import React, { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryItems = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/tech_lab_main.png",
  alt: "Advanced laboratory technical facility with precision equipment",
  className: "col-span-1 md:col-span-2 aspect-[4/3]"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/tech_sensor_detail.png",
  alt: "Precision sensor array under technical testing",
  className: "col-span-1 aspect-square"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/tech_server_rack.png",
  alt: "Industrial-grade server infrastructure for technical processing",
  className: "col-span-1 aspect-square"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/tech_control_center.png",
  alt: "Modern control center workstation for system management",
  className: "col-span-1 md:col-span-2 aspect-[16/9]"
}];
export default function GalleryPreview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (typeof window !== "undefined") {
        setScrollY(window.scrollY);
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="58117" id="project-2-overview" ref={sectionRef} className="relative w-full bg-background py-20 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Gallery Grid Column */}
          <div className="w-full lg:w-[60%]">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {galleryItems.map((item, i) => <div key={i} data-index={i} className={`relative overflow-hidden rounded-none group ${item.className} opacity-0 translate-y-8 transition-all duration-1000 ease-out shadow-2xl`} style={{
              transitionDelay: `${i * 150}ms`,
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(2rem)"
            }}>
                  {/* Image Container */}
                  <div className="absolute inset-0 w-full h-full overflow-hidden rounded-none">
                    <img src={item.src} alt={item.alt} className="w-full h-full object-cover transition-transform duration-[2000ms] ease-out group-hover:scale-105" style={{
                  transform: isVisible ? `scale(${1 + scrollY * 0.0005 % 0.1})` : "scale(1)"
                }} />
                  </div>

                  {/* High-diffusion shadow effect */}
                  <div className="absolute inset-0 pointer-events-none rounded-none shadow-[inset_0_0_60px_rgba(0,0,0,0.1)] z-10 border border-foreground/5" />
                  
                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-20" />
                </div>)}
            </div>
          </div>

          {/* Content Column */}
          <div className="w-full lg:w-[40%] relative">
            <div className="sticky top-32 flex flex-col justify-center h-full min-h-[300px] lg:min-h-[auto] bg-[#0f172a]">
              <div className={`transition-all duration-1000 delay-500 p-8 lg:p-12 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
                <h2 className="font-default text-5xl md:text-6xl lg:text-7xl text-[#f8fafc] mb-6 tracking-wide leading-[0.9]">
                  NUCETECH <br />
                  <span className="text-[#0ea5e9]">SOLUTIONS</span>
                </h2>
                
                <div className="w-16 h-1 bg-[#0ea5e9] mb-8" />

                <p className="font-sans text-lg md:text-xl text-[#f8fafc]/80 mb-10 leading-relaxed max-w-md">
                  <span className="font-mono text-xs block mb-4 uppercase tracking-widest text-[#0ea5e9]">
                    Date: 2024 • Loc: Hanoi • Tech: IoT
                  </span>
                  Engineered for high-stakes precision. Our technical infrastructure provides 
                  seamless integration and smooth motion for modern laboratory environments 
                  demanding absolute reliability.
                </p>

                <div className="flex flex-wrap gap-4">
                  <Button asChild size="lg" className="bg-[#eab308] text-[#0f172a] hover:bg-[#eab308]/90 text-base px-8 py-6 rounded-none font-medium tracking-wide shadow-lg shadow-[#eab308]/20 transition-all hover:scale-105">
                    <Link to="/SolutionsPage" aria-label="View technical solutions">
                      View Solutions
                      <ArrowRight className="ml-2 w-5 h-5" />
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}